import "./index.css";
import { Toaster } from "./components/ui/toaster";
import { Toaster as Sonner } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";

// Layout
import Layout from "./components/Layout";
import AdminLayout from "./components/AdminLayout";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import Index from "./pages/Index";
import Products from "./pages/Products";
import ProductDetails from "./pages/ProductDetails";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";

// Admin Pages
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminAboutUs from "./pages/admin/AdminAboutUs";
import AdminContactSettings from "./pages/admin/AdminContactSettings";

// Reset Password Pages
import AdminForgotPassword from "./components/AdminForgotPassword";
import AdminVerifyCode from "./components/AdminVerifyCode";
import AdminResetPassword from "./components/AdminResetPassword";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />

      {/* CHANGED BrowserRouter → HashRouter */}
      <HashRouter>
        <ScrollToTop />

        <Routes>
          {/* Public Routes */}
          <Route
            path="/"
            element={
              <Layout>
                <Index />
              </Layout>
            }
          />

          <Route
            path="/products"
            element={
              <Layout>
                <Products />
              </Layout>
            }
          />

          <Route
            path="/products/:id"
            element={
              <Layout>
                <ProductDetails />
              </Layout>
            }
          />

          <Route
            path="/about"
            element={
              <Layout>
                <About />
              </Layout>
            }
          />

          <Route
            path="/contact"
            element={
              <Layout>
                <Contact />
              </Layout>
            }
          />

          {/* Admin Routes */}
          <Route path="/login" element={<AdminLogin />} />

          <Route
            path="/admin"
            element={
              <ProtectedAdminRoute>
                <AdminLayout>
                  <AdminDashboard />
                </AdminLayout>
              </ProtectedAdminRoute>
            }
          />

          <Route
            path="/admin/products"
            element={
              <ProtectedAdminRoute>
                <AdminLayout>
                  <AdminProducts />
                </AdminLayout>
              </ProtectedAdminRoute>
            }
          />

          <Route
            path="/admin/categories"
            element={
              <ProtectedAdminRoute>
                <AdminLayout>
                  <AdminCategories />
                </AdminLayout>
              </ProtectedAdminRoute>
            }
          />

          <Route
            path="/admin/orders"
            element={
              <ProtectedAdminRoute>
                <AdminLayout>
                  <AdminOrders />
                </AdminLayout>
              </ProtectedAdminRoute>
            }
          />

          <Route
            path="/admin/users"
            element={
              <ProtectedAdminRoute>
                <AdminLayout>
                  <AdminUsers />
                </AdminLayout>
              </ProtectedAdminRoute>
            }
          />

          <Route
            path="/admin/contact"
            element={
              <ProtectedAdminRoute>
                <AdminLayout>
                  <AdminContactSettings />
                </AdminLayout>
              </ProtectedAdminRoute>
            }
          />

          <Route
            path="/admin/about"
            element={
              <ProtectedAdminRoute>
                <AdminLayout>
                  <AdminAboutUs />
                </AdminLayout>
              </ProtectedAdminRoute>
            }
          />

          {/* Reset Password Routes */}
          <Route
            path="/admin/forgot-password"
            element={<AdminForgotPassword />}
          />

          <Route path="/admin/verify-code" element={<AdminVerifyCode />} />

          <Route
            path="/admin/reset-password/:userId"
            element={<AdminResetPassword />}
          />

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
